export default {
    // HeaderFooter CMSを取得する
    getHeaderFooter: "/v1/cms/header_footer?bsCode=PG",
    // お知らせ CMSを取得する
    postTopPage: "/v1/cms/top_page",
    // CMSブロックコンテンツ取得API
    getBlockContents: "/v1/cms/block_contents",
};
